import { createAsyncThunk } from "@reduxjs/toolkit";
import { type BenefitNotification } from "../../../domain/entities/first-purchase";
import { type FirstPurchaseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getBenefit = createAsyncThunk<
  BenefitNotification,
  string,
  { dispatch: FirstPurchaseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_BENEFIT, async (requestId, { extra }) => {
  return await extra.firstPurchaseRepo.getBenefit(requestId);
});
